import { useEffect } from "react";

import { useAuth } from "@/src/auth/hooks/useAuth";

const AUTH_CHECK_INTERVAL = 5 * 60 * 1000; // 5 minutes

export const useAuthCheckTimer = () => {
  const { isAuthenticated, checkAuthorization } = useAuth();

  useEffect(() => {
    if (!isAuthenticated) return;

    const timer = setInterval(() => {
      checkAuthorization();
    }, AUTH_CHECK_INTERVAL);

    return () => {
      clearInterval(timer);
    };
  }, [isAuthenticated, checkAuthorization]);
};
